import aboutAppBills from './images/aboutAppImages/aboutAppBills.gif'
import aboutAppProfileAR from './images/aboutAppImages/aboutAppProfileAR.gif'
import aboutAppProfileEN from './images/aboutAppImages/aboutAppProfileEN.gif'
import aboutAppServiceAR from './images/aboutAppImages/aboutAppServiceAR.gif'
import aboutAppServiceEN from './images/aboutAppImages/aboutAppServiceEN.gif'
import aboutAppSwitchNumber from './images/aboutAppImages/aboutAppSwitchNumber.gif'
import aboutAppTransferBalance from './images/aboutAppImages/aboutAppTransferBalance.gif'
import AboutAppUsage from './images/aboutAppImages/AboutAppUsage.gif'
import android from './images/android.svg'
import carouselBg1 from './images/carouselBg1.svg'
import carouselBg2 from './images/carouselBg2.svg'
import carouselBg3 from './images/carouselBg3.svg'
import darkDownloadAppBG from './images/darkDownloadAppBG.svg'
import defaultImage from './images/defaultImage.svg'
import defaultImageProfile from './images/defaultImageProfile.svg'
import QR from './images/innerDownload/QR.svg'
import ios from './images/ios.svg'
import lightCorporateLogo_ltr from './images/lightCorporateLogo_ltr.png'
import lightCorporateLogo_rtl from './images/lightCorporateLogo_rtl.png'
import lightDownloadAppBG from './images/lightDownloadAppBG.svg'
import mainBg from './images/mainBg.png'
import mainBg_mobile from './images/mainBg_mobile.svg'
import noBundlesAvailable from './images/noBundlesAvailable.svg'
import noOffersAvailable from './images/noOffersAvailable.svg'
import clipboardTextIcon from './icons/clipboard-text.svg'
import OfferCardBG from './images/offerCardBG.svg'
import priceBG from './images/priceBG.svg'
import fiberIcon from './images/fiberIcon.png'
import masterCard from './images/masterCard.svg'
import VisaCard from './images/VisaCard.svg'
import darkOfferDetailsBackground from './images/darkOfferDetailsBackground.png'
import darkOfferDetailsBackgroundLTR from './images/darkOfferDetailsBackground.svg'

const IMAGES = {
  masterCard,
  VisaCard,
  carouselBg1,
  carouselBg2,
  carouselBg3,
  lightDownloadAppBG,
  darkDownloadAppBG,
  android,
  ios,
  mainBg,
  mainBg_mobile,
  QR,
  priceBG,
  OfferCardBG,
  defaultImage,
  noOffersAvailable,
  noBundlesAvailable,
  defaultImageProfile,
  lightCorporateLogo_ltr,
  aboutAppBills,
  aboutAppProfileAR,
  aboutAppProfileEN,
  aboutAppServiceAR,
  aboutAppServiceEN,
  aboutAppSwitchNumber,
  aboutAppTransferBalance,
  AboutAppUsage,
  lightCorporateLogo_rtl,
  fiberIcon,
  darkOfferDetailsBackground,
  darkOfferDetailsBackgroundLTR,
  clipboardTextIcon,
}
export default IMAGES
